import { AnyMerchant, BankAccount } from 'APIs/merchants/merchants.types';
import { H2, LpBox, Row } from 'Constants/styles';
import { ReactElement, useState } from 'react';

import BankAccountDataTable from './BankAccountDataTable';
import BankAccountModal from './BankAccountModal';

const BankAccountList = ({ merchant }: { merchant: AnyMerchant }): ReactElement => {
  const [modalBankAccount, setModalBankAccount] = useState<BankAccount | null>(null);

  return (
    <LpBox>
      <Row>
        <div className="col-sm-7">
          <H2>Bank accounts</H2>
        </div>
      </Row>

      <BankAccountDataTable bankAccountList={merchant?.bankAccounts || []} selectBankAccount={setModalBankAccount} />

      {modalBankAccount && (
        <BankAccountModal bankAccount={modalBankAccount} setModalBankAccount={setModalBankAccount} />
      )}
    </LpBox>
  );
};

export default BankAccountList;
